import React from 'react';

const LiveTeeTimesToggle = ({ enabled, onChange, loading = false, noResults = false }) => {
  const getSubtitle = () => {
    if (!enabled) return 'Showing hourly time slots based on weather and the availability you set';
    if (noResults) return 'No live tee times available. Showing hourly time slots instead';
    return 'Showing bookable tee times from GolfNow';
  };

  return (
    <div className="bg-card rounded-lg border border-border-subtle p-4 mb-6">
      <div className="flex items-center justify-between">
        <div className="flex-1 mr-4">
          <label className="text-sm font-semibold text-text-primary block">
            Show live tee times
          </label>
          <p className={`text-xs mt-1 ${enabled && noResults ? 'text-amber-600' : 'text-text-muted'}`}>
            {getSubtitle()}
          </p>
        </div>
        <button
          onClick={onChange}
          disabled={loading}
          className={`relative w-14 h-8 rounded-full transition-colors duration-200 disabled:opacity-50 ${
            enabled ? 'bg-accent' : 'bg-subtle'
          }`}
          aria-label={enabled ? 'Disable live tee times' : 'Enable live tee times'}
        >
          <span
            className={`absolute w-6 h-6 top-1 left-1 bg-card rounded-full shadow transition-transform duration-200 ${
              enabled ? 'translate-x-6' : 'translate-x-0'
            }`}
          />
        </button>
      </div>
    </div>
  );
};

export default LiveTeeTimesToggle;
